import React, { useEffect, useRef, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import { useParams } from "react-router-dom";
import JoditReact from "jodit-react";
import katex from "katex";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from "react-router-dom";

const EditQuestion = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [message, setMessage] = useState(false);
  const [question, setQuestion] = useState("");
  const [solution,setSolution]=useState("")
  const [className, setClassName] = useState("")
  const [classNames, setClassNames] = useState([])
  const [correct, setCorrect] = useState(0);
  const [selectedClasses,setSelectedClasses]=useState([])
  const [mode, setMode] = useState("exam");
const [topic, setTopic] = useState("");
const [topics, setTopics] = useState([]);
const [difficulty, setDifficulty] = useState("");
  const [subject, setSubject] = useState("")
  const [subjects, setSubjects] = useState([])
  const [exams,setExams]=useState([])
  const questionContentRef = useRef(question);
  const answerContentRef = useRef(solution);
  const option1Ref = useRef(null)
  const option2Ref = useRef(null)
  const option3Ref = useRef(null)
  const option4Ref = useRef(null)
  const [options, setOptions] = useState([option1Ref, option2Ref, option3Ref, option4Ref])
  const [fetchedOptions,setFetchedOptions]=useState([])
  const [isMathMode, setIsMathMode] = useState(false);
  const params = useParams();
  const [selectedExams, setSelectedExams] = useState([]);
  const [examsLoading,setExamsLoading]=useState(false)
  const [updateLoading,setUpdateLoading]=useState(false)
  const isInitializing = useRef(true);
  const isUserChangingMode = useRef(false);


  const data =
  mode === "exam"
    ? {
        correct,
        subject,
        className: selectedClasses.join(','),
        exams: selectedExams
      }
    : {
        correct,
        subject,
        topic,
        difficulty
      };

  useEffect(() => {
    const timer = setTimeout(() => {
      setMessage(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [message]);
  const editorConfig={
    readonly: false,
    tabIndex: 1,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_clear_html",
    placeholder: "Type your description here ...",
    beautyHTML: true,
    toolbarButtonSize: "small",
    addNewLine: false,
    buttons: [
      "bold",
      "italic",
      'subscript', 
      'superscript',
      "|",
      "ul",
      "ol",
      "|",
      "font",
      "fontsize",
      "brush",
      "|",
      "table",
      "|",
      "left",
      "center",
      "right",
      "justify",
      "|",
      "undo",
      "redo",
      "|",
      "hr",
      "fullsize", 
    ],
    extraButtons: [
      // {
      //   name: "image",
      //   tooltip: "Insert Image",
      //   exec: (editor) => {
      //     const input = document.createElement("input");
      //     input.type = "file";
      //     input.accept = "image/*";
      //     input.addEventListener("change", async (e) => {
      //       const file = e.target.files[0]; // Get the file from the input
        
      //       if (file) {
      //         // Create FormData to send the file to the backend
      //         const formData = new FormData();
      //         formData.append("file", file); // Append the image file
        
      //         try {
      //           // Send the image to the backend server
      //           const response = await axios.post(`${baseUrl}/question/upload-image`, formData, {
      //             headers: {
      //               "Content-Type": "multipart/form-data", // Ensure the correct content type
      //             },
      //           });

      //           const imageUrl = response.data.url;
        
      //           // Insert the uploaded image URL into the Jodit editor
      //           editor.selection.insertImage(imageUrl);
      //         } catch (err) {
      //           console.error("Error uploading image:", err);
      //         }
      //       }
      //     });
      //     input.click();
      //   },
      // },
      {
        name: "symbols",
        icon: "fa fa-smile-o",
        tooltip: "Insert Symbol",
        exec: (editor) => {
          // Define the custom symbols
          const customSymbols = [
            { symbol: '€', title: 'Euro' },
            { symbol: '£', title: 'Pound Sterling' },
            { symbol: '¥', title: 'Yen' },
            { symbol: '₹', title: 'Indian Rupee' },
            { symbol: '$', title: 'Dollar' },
            { symbol: '₣', title: 'Franc' },
            { symbol: '₣', title: 'Lira (Turkish)' },
            { symbol: '±', title: 'Plus-Minus' },
            { symbol: '÷', title: 'Division Sign' },
            { symbol: '×', title: 'Multiplication Sign' },
            { symbol: '≠', title: 'Not Equal' },
            { symbol: '≈', title: 'Approximate Equal' },
            { symbol: '∞', title: 'Infinity' },
            { symbol: '√', title: 'Square Root' },
            { symbol: 'π', title: 'Pi' },
            { symbol: '∑', title: 'Summation' },
            { symbol: '∏', title: 'Product' },
            { symbol: '∈', title: 'Element Of' },
            { symbol: '∩', title: 'Intersection' },
            { symbol: '∪', title: 'Union' },
            { symbol: '∧', title: 'Logical AND' },
            { symbol: '∨', title: 'Logical OR' },
            { symbol: 'α', title: 'Alpha' },
            { symbol: 'β', title: 'Beta' },
            { symbol: 'γ', title: 'Gamma' },
            { symbol: 'δ', title: 'Delta' },
            { symbol: 'ε', title: 'Epsilon' },
            { symbol: 'λ', title: 'Lambda' },
            { symbol: 'μ', title: 'Mu' },
            { symbol: 'σ', title: 'Sigma' },
            { symbol: 'τ', title: 'Tau' },
            { symbol: 'φ', title: 'Phi' },
            { symbol: 'Ω', title: 'Omega' },
            { symbol: '©', title: 'Copyright' },
            { symbol: '®', title: 'Registered Trademark' },
            { symbol: '™', title: 'Trademark' },
            { symbol: '♥', title: 'Heart' },
            { symbol: '★', title: 'Star' },
            { symbol: '☼', title: 'Sun' },
            { symbol: '☽', title: 'Crescent Moon' },
            { symbol: '☃', title: 'Snowman' },
            { symbol: '☠', title: 'Skull and Crossbones' },
            { symbol: '✈', title: 'Airplane' },
            { symbol: '⚡', title: 'High Voltage' },
            { symbol: '✿', title: 'Flower' },
            { symbol: '☘', title: 'Shamrock' },
            { symbol: '☀', title: 'Sun Symbol' },
            { symbol: '☁', title: 'Cloud Symbol' },
            { symbol: '☂', title: 'Umbrella Symbol' },
            { symbol: '→', title: 'Right Arrow' },
            { symbol: '←', title: 'Left Arrow' },
            { symbol: '↑', title: 'Up Arrow' },
            { symbol: '↓', title: 'Down Arrow' },
            { symbol: '↔', title: 'Left-Right Arrow' },
            { symbol: '↕', title: 'Up-Down Arrow' },
            { symbol: '↗', title: 'Up-Right Arrow' },
            { symbol: '↖', title: 'Up-Left Arrow' },
            { symbol: '§', title: 'Section Symbol' },
            { symbol: '¶', title: 'Paragraph Symbol' },
            { symbol: '°', title: 'Degree Symbol' },
            { symbol: '≡', title: 'Identical To' },
            { symbol: '∞', title: 'Infinity' },
            { symbol: '≠', title: 'Not Equal' }
          ];
          

          // Build the HTML content for the custom symbols
          const symbolButtons = customSymbols
            .map(
              (symbol) =>
                `<button class="jodit-symbol-btn" title="${symbol.title}" onclick="insertSymbol('${symbol.symbol}')">${symbol.symbol}</button>`
            )
            .join(" ");

          // Show a modal to select a symbol
          const modal = document.createElement('div');
          modal.classList.add('jodit-symbol-modal');
          modal.innerHTML = `
            <div class="jodit-symbol-modal-content">
              <h3>Select a Symbol</h3>
              <div class="symbol-buttons">${symbolButtons}</div>
              <button class="jodit-close-btn">Close</button>
            </div>
          `;
          document.body.appendChild(modal);

          // Close modal handler
          modal.querySelector('.jodit-close-btn').addEventListener('click', () => {
            document.body.removeChild(modal);
          });

          // Insert the symbol into the editor
          window.insertSymbol = function(symbol) {
            editor.selection.insertHTML(symbol);
            document.body.removeChild(modal);
          };
        }
      },
      {
        name: "math",
        tooltip: "Insert LaTeX",
        exec: (editor) => {
          const latexInput = prompt("Enter LaTeX expression:");
          if (latexInput) {
            const filteredInput = latexInput.replace(/^\\?\[|\\]$/g, '').trim();
            try {
              const renderedLatex = katex.renderToString(filteredInput, {
                throwOnError: false,
                displayMode: false, // Optional: controls whether LaTeX is displayed inline or block
                output: 'mathml' // We only need the MathML part
              });
              editor.selection.insertHTML(renderedLatex);
            } catch (error) {
              alert("Invalid LaTeX expression.");
            }
          }
        },
      } 
    ], // Ensure no extra buttons (e.g., speech) are added
    disablePlugins: ["speech"], // Explicitly disable speech recognition
    toolbarAdaptive: false, 
  }
  const editorConfig2={
    readonly: false,
    tabIndex: 1,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_clear_html",
    placeholder: "Type your description here ...",
    beautyHTML: true,
    toolbarButtonSize: "small",
    addNewLine: false,
    buttons: [
      "bold",
      "italic",
      'subscript', 
      'superscript',
      "|",
      "font",
      "fontsize",
      "table",
      "|",
    ],
    extraButtons: [
      // {
      //   name: "image",
      //   tooltip: "Insert Image",
      //   exec: (editor) => {
      //     const input = document.createElement("input");
      //     input.type = "file";
      //     input.accept = "image/*";
      //     input.addEventListener("change", async (e) => {
      //       const file = e.target.files[0]; // Get the file from the input

      //       if (file) {
      //         // Create FormData to send the file to the backend
      //         const formData = new FormData();
      //         formData.append("file", file); // Append the image file

      //         try {
      //           // Send the image to the backend server
      //           const response = await axios.post(`${baseUrl}/question/upload-image`, formData, {
      //             headers: {
      //               "Content-Type": "multipart/form-data", // Ensure the correct content type
      //             },
      //           });

      //           const imageUrl = response.data.url;

      //           // Insert the uploaded image URL into the Jodit editor
      //           editor.selection.insertImage(imageUrl);
      //         } catch (err) {
      //           console.error("Error uploading image:", err);
      //         }
      //       }
      //     });
      //     input.click();
      //   },
      // },
      {
        name: "symbols",
        icon: "fa fa-smile-o",
        tooltip: "Insert Symbol",
        exec: (editor) => {
          // Define the custom symbols
          const customSymbols = [
            { symbol: '€', title: 'Euro' },
            { symbol: '£', title: 'Pound Sterling' },
            { symbol: '¥', title: 'Yen' },
            { symbol: '₹', title: 'Indian Rupee' },
            { symbol: '$', title: 'Dollar' },
            { symbol: '₣', title: 'Franc' },
            { symbol: '₣', title: 'Lira (Turkish)' },
            { symbol: '±', title: 'Plus-Minus' },
            { symbol: '÷', title: 'Division Sign' },
            { symbol: '×', title: 'Multiplication Sign' },
            { symbol: '≠', title: 'Not Equal' },
            { symbol: '≈', title: 'Approximate Equal' },
            { symbol: '∞', title: 'Infinity' },
            { symbol: '√', title: 'Square Root' },
            { symbol: 'π', title: 'Pi' },
            { symbol: '∑', title: 'Summation' },
            { symbol: '∏', title: 'Product' },
            { symbol: '∈', title: 'Element Of' },
            { symbol: '∩', title: 'Intersection' },
            { symbol: '∪', title: 'Union' },
            { symbol: '∧', title: 'Logical AND' },
            { symbol: '∨', title: 'Logical OR' },
            { symbol: 'α', title: 'Alpha' },
            { symbol: 'β', title: 'Beta' },
            { symbol: 'γ', title: 'Gamma' },
            { symbol: 'δ', title: 'Delta' },
            { symbol: 'ε', title: 'Epsilon' },
            { symbol: 'λ', title: 'Lambda' },
            { symbol: 'μ', title: 'Mu' },
            { symbol: 'σ', title: 'Sigma' },
            { symbol: 'τ', title: 'Tau' },
            { symbol: 'φ', title: 'Phi' },
            { symbol: 'Ω', title: 'Omega' },
            { symbol: '©', title: 'Copyright' },
            { symbol: '®', title: 'Registered Trademark' },
            { symbol: '™', title: 'Trademark' },
            { symbol: '♥', title: 'Heart' },
            { symbol: '★', title: 'Star' },
            { symbol: '☼', title: 'Sun' },
            { symbol: '☽', title: 'Crescent Moon' },
            { symbol: '☃', title: 'Snowman' },
            { symbol: '☠', title: 'Skull and Crossbones' },
            { symbol: '✈', title: 'Airplane' },
            { symbol: '⚡', title: 'High Voltage' },
            { symbol: '✿', title: 'Flower' },
            { symbol: '☘', title: 'Shamrock' },
            { symbol: '☀', title: 'Sun Symbol' },
            { symbol: '☁', title: 'Cloud Symbol' },
            { symbol: '☂', title: 'Umbrella Symbol' },
            { symbol: '→', title: 'Right Arrow' },
            { symbol: '←', title: 'Left Arrow' },
            { symbol: '↑', title: 'Up Arrow' },
            { symbol: '↓', title: 'Down Arrow' },
            { symbol: '↔', title: 'Left-Right Arrow' },
            { symbol: '↕', title: 'Up-Down Arrow' },
            { symbol: '↗', title: 'Up-Right Arrow' },
            { symbol: '↖', title: 'Up-Left Arrow' },
            { symbol: '§', title: 'Section Symbol' },
            { symbol: '¶', title: 'Paragraph Symbol' },
            { symbol: '°', title: 'Degree Symbol' },
            { symbol: '≡', title: 'Identical To' },
            { symbol: '∞', title: 'Infinity' },
            { symbol: '≠', title: 'Not Equal' }
          ];
          

          // Build the HTML content for the custom symbols
          const symbolButtons = customSymbols
            .map(
              (symbol) =>
                `<button class="jodit-symbol-btn" title="${symbol.title}" onclick="insertSymbol('${symbol.symbol}')">${symbol.symbol}</button>`
            )
            .join(" ");

          // Show a modal to select a symbol
          const modal = document.createElement('div');
          modal.classList.add('jodit-symbol-modal');
          modal.innerHTML = `
            <div class="jodit-symbol-modal-content">
              <h3>Select a Symbol</h3>
              <div class="symbol-buttons">${symbolButtons}</div>
              <button class="jodit-close-btn">Close</button>
            </div>
          `;
          document.body.appendChild(modal);

          // Close modal handler
          modal.querySelector('.jodit-close-btn').addEventListener('click', () => {
            document.body.removeChild(modal);
          });

          // Insert the symbol into the editor
          window.insertSymbol = function(symbol) {
            editor.selection.insertHTML(symbol);
            document.body.removeChild(modal);
          };
        }
      },
      {
        name: "math",
        tooltip: "Insert LaTeX",
        exec: (editor) => {
          const latexInput = prompt("Enter LaTeX expression:");
          if (latexInput) {
            const filteredInput = latexInput.replace(/^\\?\[|\\]$/g, '').trim();
            try {
              const renderedLatex = katex.renderToString(filteredInput, {
                throwOnError: false,
                displayMode: false, // Optional: controls whether LaTeX is displayed inline or block
                output: 'mathml' // We only need the MathML part
              });
              editor.selection.insertHTML(renderedLatex);
            } catch (error) {
              alert("Invalid LaTeX expression.");
            }
          }
        },
      }

    ],
    disablePlugins: ["speech"],
    toolbarAdaptive: false, 
  }

  const handleQuestionContent = (newContent) => {
    if (questionContentRef.current) {
      questionContentRef.current = newContent;
    }
  };
  
    const handleAnswerContent = (newContent) => {
      if (answerContentRef.current) {
        answerContentRef.current = newContent;
      }
    };


    const handleMathInputChange = (e) => {
      const mathExpression = e.target.value;
      const editor = questionContentRef.current?.editor; // Access the Jodit editor instance
      if (editor && isMathMode) {
        try {
          const renderedMath = katex.renderToString(mathExpression, {
            throwOnError: false,
          });
          editor.selection.insertHTML(renderedMath); // Insert at the current cursor position
          console.log(editor)
        } catch (error) {
          console.error("Invalid LaTeX expression:", error);
        }
      }
    };

  useEffect(() => {
    axios.get(`${baseUrl}/subject/all`)
    .then(res=>setSubjects(res.data))
    .catch(err=>console.log(err))
    axios.get(`${baseUrl}/course/all`)
    .then(res=>setClassNames(res.data))
    axios.get(`${baseUrl}/exam/all`)
    .then(res=>setExams(res.data))
    axios
      .get(`${baseUrl}/question/get?id=${params.id}`)
      .then((res) => {
        const q = res.data.question;
        setQuestion(res.data.question.question);
        setSolution(res.data.question.solution)
        setFetchedOptions([res.data.question.options[0],res.data.question.options[1],res.data.question.options[2],res.data.question.options[3]]);
        setCorrect(res.data.question.correct);
        setSubject(res.data.question.subject)

        if (q.topic) {
          setMode("topic");
          setTopic(q.topic?._id || q.topic);
          setDifficulty(q.difficulty || "");
          setSelectedClasses([]);
          setSelectedExams([]);

        } else {
          setMode("exam");
          setClassName(q.class);
          setSelectedClasses(q.class?.split(',') || []);
          setSelectedExams(res.data.exams?.map(e => e._id) || []);
        }
         isInitializing.current = false;
      })
      .catch((err) => {console.log(err)});
  }, []);

  useEffect(() => {
    if (subject) {
      axios
        .get(`${baseUrl}/topic/by-subject?subject=${subject}`)
        .then(res => setTopics(res.data))
        .catch(err => console.log(err));
    } else {
      setTopics([]);
    }
  }, [subject]);

  useEffect(() => {
    if (selectedClasses.length > 0) {
      setExamsLoading(true)

      const classesQuery = selectedClasses.join(','); // Join selected classes to pass as query

      // Fetch exams based on selected classes
      axios.get(`${baseUrl}/exam/get/by-class?className=${classesQuery}`)
        .then(res => {
          setExams(res.data.data);
          setExamsLoading(false)
        })
        .catch(err => {
          console.error("Error fetching exams: ", err);
          setExamsLoading(false)
        });
    }
  }, [selectedClasses]);

  const topicsLoaded = topics.length > 0;

  useEffect(() => {
    if (isInitializing.current) return;
    if (!topicsLoaded) return;

    if (!topic) return;

    const exists = topics.some(t => String(t._id) === String(topic));

    if (!exists) {
      setTopic("");
    }
  }, [topicsLoaded, topic]);

  useEffect(() => {
    if (!isUserChangingMode.current) return;

    setSelectedExams([]);
    setSelectedClasses([]);
    setTopic("");
    setDifficulty("");

    isUserChangingMode.current = false; // reset flag
  }, [mode]);


  const handleSubmit = () => {
    setUpdateLoading(true)
    axios.post(`${baseUrl}/question/update?id=${params.id}`, {
      ...data,
      question: questionContentRef.current?.value || questionContentRef.current,
      answer: answerContentRef.current?.value || answerContentRef.current,
      options
    })

      .then((res) => {
        if (res.data === "success") setMessage("Question updated successfully");setUpdateLoading(false)
      })
      .catch((err) => {setMessage(err.response?.data);setUpdateLoading(false)});
  };

  const handleOptionChange = (index, value) => {
    const updatedOptions = [...options];
    updatedOptions[index] = value;
    setOptions(updatedOptions);
  };

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
      <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link className="text-decoration-none">Questions</Link>
              </li>
              <li className="breadcrumb-item active">
                Edit
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div className="mb-3">
          <label className="form-label fs-5">Select Mode :</label>
          <div>
            <button
              className={`btn btn-sm me-2 ${mode === "exam" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => {
                isUserChangingMode.current = true;
                setMode("exam")
              }}
            >
              Exam Wise
            </button>

            <button
              className={`btn btn-sm ${mode === "topic" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => {
                isUserChangingMode.current = true;
                setMode("topic")
              }}
            >
              Topic Wise
            </button>
          </div>
        </div>

        <div
          className={`container-fluid`}>
          <div className="bg-white p-4">
            <h4>Edit Question</h4>
            <div className="row">
              <div className="col-lg-7">
                <label htmlFor="question" className="form-label fs-4">
                  Question :
                </label>
                <JoditReact
                ref={questionContentRef}
                config={editorConfig}
                onChange={handleQuestionContent}
                value={question}
                // value={questionContentRef.current || ''}
              />
                          <label htmlFor="solution" className="form-label fs-4">
                  Solution :
                </label>
            <JoditReact
                ref={answerContentRef}
                config={editorConfig}
                onChange={handleAnswerContent} 
                value={solution}
                // value={answerContentRef.current || ''}
              />
              </div>
              <div className="col-lg-5">
              <label htmlFor="options" className="form-label">
                  Options
                </label>
                  {options.map((o, index) => (
                    <div key={index} className="col">
                      <label htmlFor={`option${index}`} className="form-label">
                        Option {index + 1}:
                      </label>
                      <JoditReact
                      ref={o}
                      config={{
                        ...editorConfig2, 
                        minHeight:110,
                        height: 110,
                        placeholder: `Option : ${index+1}`,
                      }}
                      value={`${fetchedOptions[index]}`}
                      onChange={(newContent) => {
                        if (o.current) {
                          // Ensure that the ref is updated with new content, even when it's empty
                          if (newContent === "") {
                            o.current = "<p></p>"; // If the content is cleared, make sure the ref is set to an empty string
                          } else {
                            o.current = newContent; // Otherwise, set it to the new content
                          }
                        }
                      }}
                    />
                    </div>
                  ))}
              </div>

              {isMathMode && (
                <div className="mt-3">
                  <textarea
                    className="form-control"
                    rows="2"
                    placeholder="Type your LaTeX math expression"
                    onChange={handleMathInputChange}
                  ></textarea>
                  <p>Type a math expression</p>
                </div>
              )}
            </div>
            <div className="row mb-3">
              <div className="col-lg-3">
                <label htmlFor="correct" className="form-label fs-4">
                  Correct :
                </label>
                <select
                  className="form-select"
                  id="correctAnswer"
                  value={correct}
                  onChange={(e) => setCorrect(e.target.value)}
                  required
                >
                  <option value="" hidden>Select correct</option>
                  {[...Array(4)].map((option, index) => (
                    <option key={index} value={index + 1}>
                      Option {index + 1}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-3">
              <label htmlFor="subject" className="form-label fs-4">
                  Subject :
                </label>
                <select
                  className="form-select"
                  id="subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                >
                  <option value="" hidden>Select Subject</option>
                  {subjects.map((c, index) => (
                    <option key={index}>
                      {c.subjectName}
                    </option>
                  ))}
                </select>
              </div>
              {mode === "topic" && (
                <>
                  <div className="col-lg-3">
                    <label className="form-label fs-4">Topic :</label>
                    <select
                      className="form-select"
                      value={topic}
                      onChange={(e) => setTopic(e.target.value)}
                    >
                      <option value="" hidden>Select Topic</option>
                      {topics.map((t) => (
                        <option key={t._id} value={t._id}>
                          {t.topicName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-3">
                    <label className="form-label fs-4">Difficulty :</label>
                    <select
                      className="form-select"
                      value={difficulty}
                      onChange={(e) => setDifficulty(e.target.value)}
                    >
                      <option value="" hidden>Select Difficulty</option>
                      <option value="easy">Easy</option>
                      <option value="medium">Medium</option>
                      <option value="hard">Hard</option>
                    </select>
                  </div>
                </>
              )}

            </div>
            {mode === "exam" && (
            <div className="row mb-3">
            <div className="col-lg-3">
              <label htmlFor="class" className="form-label fs-4">
                  Class :
                </label>
                <select
                  className="form-select"
                  id="class"
                  value={selectedClasses}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedClasses((prev) =>
                      prev.includes(value) ? prev.filter((id) => id !== value) : [...prev, value]
                    );
                  }}
                  required
                  multiple
                >
                  <option value="" hidden>Select Class</option>
                    <option>
                      Class XI
                    </option>
                    <option>
                      Class XII
                    </option>
                    <option>
                      Class XII Passed
                    </option>
                </select>
              </div>
              <div className="col-lg-6">
                <label htmlFor="exam" className="form-label">
                  Select Exam
                </label>
                {
                  examsLoading&&
                  <><br/><img src="/assets/images/load-time.gif" width='50px' alt="loading"/></>
                }
                {
                  !examsLoading&&exams.length>0&&
                  <select
                  className="form-select"
                  id="exam"
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedExams((prev) =>
                      prev.includes(value) ? prev.filter((id) => id !== value) : [...prev, value]
                    );
                  }}
                  multiple
                  value={selectedExams}
                >
                  {
                    exams.map((e) => (
                      <option key={e._id} value={e._id}>
                        {e.examName} ({e.className})
                      </option>
                    ))
                  } 
                </select>
                }
                {
                  !examsLoading&&exams.length<1&&
                    <p className="text-danger">
                      No active exam found for selected class
                    </p>
                }
              </div>
              {/* <div className="col-lg-4">
                <label htmlFor="exam" className="form-label">
                  Exam
                </label>
                <select
                  className="form-select"
                  id="exam"
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedExams((prev) =>
                      prev.includes(value) ? prev.filter((id) => id !== value) : [...prev, value]
                    );
                  }}
                  multiple
                  value={selectedExams}
                >
                  {exams.map((e) => (
                    <option key={e._id} value={e._id}>
                      {e.examName}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>
            )}
            {message && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-3"
                role="alert"
              >
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage(false)}
                ></button>
              </div>
            )}
            <button disabled={updateLoading} onClick={handleSubmit} className="btn btn-primary mt-4">
              {updateLoading?'Processing ...':'Update'}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditQuestion;
